module.exports = __webpack_public_path__ + "static/media/NotoSans-Regular.2fd9c16b.ttf";